import { render, staticRenderFns } from "./ChangeRequestsPick.vue?vue&type=template&id=cb56e6ac"
import script from "./ChangeRequestsPick.vue?vue&type=script&lang=ts"
export * from "./ChangeRequestsPick.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports